import { Grid, Card, CardHeader, CardContent, Button, Typography } from '@mui/material';

import { stateApiKeyStore } from '../../../api/states-api-key-store';
import { customersApiKeyStore } from '../../../api/customers-api-key-store';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormSelectDynamic } from '../../../components/hook-form/form-select.dynamic.component';
import { PHONENUMBER_FORMAT, ZIPCODE_FORMAT } from '../../../constants';
import { FormFormattedInput } from '../../../components/hook-form/form-formatted-input.component';
import { useReactHookForm } from '../../../hooks/useReactHookForm';
import { useFormContext } from 'react-hook-form';
import { officeApiKeyStore } from '../../../api/office-api-key-store';

const styling = {
  paperStyle: { padding: '20px', borderRadius: '20px' },
  headingStyle: { fontWeight: 'bold' },
};

export interface Option {
  value: any;
  label: string;
  isDefault: boolean;
}

export const BillingDetailsForm = () => {
  const { getValues, setValue, trigger } = useFormContext();

  const handleCopyContactClick = () => {
    setValue('billingStreet', getValues('contactStreet'));
    setValue('billingCity', getValues('contactCity'));
    // !getValues('state')?.stateID ? 0 : getValues('state')?.stateID
    setValue('billingState', !getValues('contactState') ? 0 : getValues('contactState'));
    setValue('billingZip', getValues('contactZip'));
    setValue('billingPhone', getValues('contactPhone'));
    setValue('billingEmail', getValues('contactEmail'));
    trigger();
  };

  return (
    <Card elevation={0}>
      <CardHeader
        className="subHead"
        title={
          <Typography variant="h3" color="textPrimary" style={styling.headingStyle}>
            BILLING DETAILS
          </Typography>
        }
        action={
          <Button className="btnLink" sx={{ p: 0, m: 0, mr: 1 }} variant="text" onClick={handleCopyContactClick}>
            Copy Address
          </Button>
        }
      ></CardHeader>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item lg={3} sm={3} xl={3} xs={3}>
            {/* <FormSelectDynamic
              name="invoiceTermID"
              label="Invoice Due Days"
              getQueryKeyConfig={() => customersApiKeyStore.getInvoiceTerms()}
              optionsValueKey="invoiceTermID"
              optionsLabelKeys={['invoiceTermText']}
            /> */}
            <FormSelectDynamic
              name="qboTermID"
              label="Terms"
              required
              getQueryKeyConfig={() => officeApiKeyStore.getQBOTerms()}
              optionsValueKey="qboTermID"
              optionsLabelKeys={['qboName']}
            />
          </Grid>
          <Grid item lg={3} sm={3} xl={3} xs={3}>
            <FormInput name="billingStreet" label="Street Address" />
          </Grid>
          <Grid item lg={3} sm={3} xl={3} xs={3}>
            <FormInput name="billingCity" label="City" />
          </Grid>
          <Grid item lg={3} sm={3} xl={3} xs={3}>
            <FormSelectDynamic
              name="billingState"
              label="State"
              getQueryKeyConfig={() => stateApiKeyStore.getStates()}
              optionsValueKey="stateID"
              optionsLabelKeys={['stateName']}
            />
          </Grid>
          <Grid item lg={3} sm={3} xl={3} xs={3}>
            <FormFormattedInput name="billingZip" label="Zip Code" format={ZIPCODE_FORMAT} />
          </Grid>
          <Grid item lg={3} sm={3} xl={3} xs={3}>
            <FormInput name="billingContactAddress" label="Billing Contact" />
          </Grid>
          <Grid item lg={3} sm={3} xl={3} xs={3}>
            <FormFormattedInput name="billingPhone" label="Billing Phone" format={PHONENUMBER_FORMAT} />
          </Grid>
          <Grid item lg={3} sm={3} xl={3} xs={3}>
            <FormInput name="billingEmail" label="Billing Email" />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
